export default "__VITE_ASSET__DJrF9rg8__"